import { Input, Label } from "reactstrap";
import {
  STATUS_DATA_TYPE,
  StatusDataAkunBaru,
  StatusDataRealokasi,
  StatusDataTransaksi,
  StatusDataUMK,
  StatusDataUMO,
} from "../../Constant/StatusData";

const FilterStatus = ({ setSelectedStatus, statusDataType }) => {
  const getStatusDropdown = (statusDataType) => {
    switch (statusDataType) {
      case STATUS_DATA_TYPE.UMK:
        return StatusDataUMK.map((status) => (
          <option key={status.id} value={status.id}>
            {status.nama_status}
          </option>
        ));
      case STATUS_DATA_TYPE.UMO:
        return StatusDataUMO.map((status) => (
          <option key={status.id} value={status.id}>
            {status.nama_status}
          </option>
        ));
      case STATUS_DATA_TYPE.Transaksi:
        return StatusDataTransaksi.map((status) => (
          <option key={status.id} value={status.id}>
            {status.nama_status}
          </option>
        ));
      case STATUS_DATA_TYPE.Realokasi:
        return StatusDataRealokasi.map((status) => (
          <option key={status.id} value={status.id}>
            {status.nama_status}
          </option>
        ));
      case STATUS_DATA_TYPE.AkunBaru:
        return StatusDataAkunBaru.map((status) => (
          <option key={status.id} value={status.id}>
            {status.nama_status}
          </option>
        ));
      default:
        return null;
    }
  };

  return (
    <>
      <Label className="bg-transparent">Status</Label>
      <Input type="select" onChange={(e) => setSelectedStatus(e.target.value)}>
        <option value={0}>Semua</option>
        {getStatusDropdown(statusDataType)}
      </Input>
    </>
  );
};

export default FilterStatus;
